function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M27.832 9.463c-7.337 9.541-15.39 8.135-13.409 8.124-3.082 0-6.388-1.414-9.565-4.09A25.915 25.915 0 0 1 .999 9.459a.894.894 0 0 1 0-1.056C1.958 7.159 7.314.42 14.423.281c7.383 0 13.179 7.794 13.421 8.126a.893.893 0 0 1-.012 1.056zM14.423 2.072C8.28 2.187 3.351 8.349 2.867 8.935c1.393 1.692 6.119 6.862 11.556 6.862-1.609.012 4.931 1.194 11.556-6.862-1.393-1.692-6.119-6.863-11.556-6.863zm.085 11.927a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM14.5 5.708a3.292 3.292 0 1 0 0 6.584 3.292 3.292 0 0 0 0-6.584z"
});

var SvgShow = function SvgShow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/show.211ecac7.svg";
export { ForwardRef as ReactComponent };